// checklistDetailSections — single source of truth for which detail
// sections render inside the checklist details popup (NodeDetailDrawer
// content), and which sections have been merged together.
//
// The visibility map is hard-coded true today; flipping any entry to false
// hides that section everywhere the popup is used. When we later expose a
// settings surface (per-workspace or per-user), it should write into this
// same shape so the popup stays consumer-agnostic.
//
// Combined sections (per user request 2026-08-07):
//   - Basics + Risk & Resources → "Details"
//   - Verification + Attachments → "Proof & Attachments"
//   - Recurrence + occurrence sidebar → visually grouped under "Recurrence"
//   - Appearance hosts the location breadcrumb → "Appearance & Location"
//
// Section ids are stable strings — the render pipelines key visibility
// lookups off them, so treat any rename here as a breaking change.

export type ChecklistDetailSectionId =
  | 'details'
  | 'financials'
  | 'dependencies'
  | 'discussion'
  | 'proofAndAttachments'
  | 'appearance'
  | 'stock'
  | 'recurrence'

export type ChecklistDetailSectionConfig = {
  visible: boolean
  /** Copy shown on the section header (kept centralised so the popup + any
   *  future settings toggle read from the same map). */
  label: string
}

export const CHECKLIST_DETAIL_SECTIONS: Record<ChecklistDetailSectionId, ChecklistDetailSectionConfig> = {
  details: { visible: true, label: 'Details' },
  financials: { visible: true, label: 'Financials' },
  dependencies: { visible: true, label: 'Dependencies' },
  discussion: { visible: true, label: 'Discussion' },
  proofAndAttachments: { visible: true, label: 'Proof & Attachments' },
  appearance: { visible: true, label: 'Appearance & Location' },
  stock: { visible: true, label: 'Stock' },
  recurrence: { visible: true, label: 'Recurrence' },
}

export const isSectionVisible = (id: ChecklistDetailSectionId): boolean =>
  CHECKLIST_DETAIL_SECTIONS[id]?.visible !== false

export const sectionLabel = (id: ChecklistDetailSectionId): string =>
  CHECKLIST_DETAIL_SECTIONS[id]?.label ?? id
